/* Photographic smoke density with continuous turbulent displacement. No scroll interception. */
window.AWSSmoke = (() => {
  const vertex = `attribute vec2 a_position;
  varying vec2 v_uv;
  void main(){v_uv=vec2(a_position.x*.5+.5,.5-a_position.y*.5);gl_Position=vec4(a_position,0.,1.);}`;
  const fragment = `
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
  varying vec2 v_uv;
  uniform sampler2D u_smoke;
  uniform vec2 u_size;
  uniform vec2 u_origin;
  uniform float u_time;
  uniform float u_progress;
  float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
  float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.,1.)),f.x),f.y);}
  float plume(vec2 px,vec2 origin,vec2 size,float phase,float mirror){
    vec2 uv=vec2(.5,.97)+(px-origin)/size;
    float rise=clamp((origin.y-px.y)/size.y,0.,1.);
    // The base stays attached to the cigar; only the rising smoke curls.
    uv.x+=(noise(vec2(uv.y*4.+phase,u_time*.19+phase))-.5)*.15*rise;
    uv.x+=sin(uv.y*8.-u_time*.65+phase)*.025*rise;
    uv.y+=(noise(vec2(uv.x*5.+phase,uv.y*4.+u_time*.15))-.5)*.05*rise;
    if(mirror>0.)uv.x=1.-uv.x;
    if(uv.x<0.||uv.x>1.||uv.y<0.||uv.y>1.)return 0.;
    float l=dot(texture2D(u_smoke,uv).rgb,vec3(.299,.587,.114));
    float edge=smoothstep(0.,.055,uv.x)*smoothstep(0.,.055,1.-uv.x)*smoothstep(0.,.07,uv.y)*smoothstep(0.,.025,1.-uv.y);
    return pow(max(0.,l-.022),.88)*edge;
  }
  void main(){
    vec2 px=v_uv*u_size;
    float amp=smoothstep(.04,.59,u_progress);
    float clear=1.-smoothstep(.55,.92,u_progress);
    vec2 origin=mix(u_origin,vec2(u_size.x*.52,u_size.y*.92),amp*.85);
    float span=min(u_size.x,u_size.y);
    vec2 size=vec2(span*(.37+amp*2.9),min(u_size.y*.8,520.)*(1.+amp*2.6));
    float d=plume(px,origin,size,0.,0.)*.9;
    d+=plume(px,origin+vec2(sin(u_time*.27)*14.*amp,0.),size*vec2(.83,1.10),2.5,1.)*(.20+amp*.45);
    d+=plume(px,origin+vec2(-span*.32*amp,span*.08*amp),size*vec2(1.1,.9),5.,0.)*amp*.65;
    d+=plume(px,origin+vec2(span*.40*amp,span*.18*amp),size*vec2(.85,1.2),8.,1.)*amp*.6;
    float alpha=(1.-exp(-d*(1.2+amp*1.7)))*clear;
    vec3 ink=mix(vec3(.23,.24,.23),vec3(.52,.53,.51),clamp(d*.8,0.,1.));
    gl_FragColor=vec4(ink,alpha);
  }`;
  function create(canvas,url,ready){
    if(!url)return null;
    const gl=canvas.getContext('webgl',{alpha:true,premultipliedAlpha:false,antialias:false,depth:false,powerPreference:'low-power'});
    if(!gl)return fallback(canvas,url,ready);
    let disposed=false,loaded=false,lost=false,program,texture,buffer;
    const shaders=[];
    try {
      function compile(type,source){const s=gl.createShader(type);shaders.push(s);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('Smoke shader unavailable');return s;}
      program=gl.createProgram();gl.attachShader(program,compile(gl.VERTEX_SHADER,vertex));gl.attachShader(program,compile(gl.FRAGMENT_SHADER,fragment));gl.linkProgram(program);
      if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Smoke renderer unavailable');
      gl.useProgram(program);buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),gl.STATIC_DRAW);
      const pos=gl.getAttribLocation(program,'a_position');gl.enableVertexAttribArray(pos);gl.vertexAttribPointer(pos,2,gl.FLOAT,false,0,0);
      texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,texture);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
    } catch {cleanup();return null;}
    const uniforms={};['u_size','u_origin','u_time','u_progress','u_smoke'].forEach(n=>uniforms[n]=gl.getUniformLocation(program,n));
    const img=new Image();img.crossOrigin='anonymous';
    img.onload=()=>{if(disposed||lost)return;try{gl.bindTexture(gl.TEXTURE_2D,texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,img);loaded=true;ready();}catch{loaded=false;ready();}};
    img.onerror=()=>{loaded=false;ready();};img.src=url;
    function onLost(e){e.preventDefault();lost=true;loaded=false;ready();}
    // Fall back to a normal readable page if the GPU is reclaimed by the phone.
    canvas.addEventListener('webglcontextlost',onLost);
    function cleanup(){if(texture)gl.deleteTexture(texture);if(buffer)gl.deleteBuffer(buffer);if(program)gl.deleteProgram(program);shaders.forEach(s=>gl.deleteShader(s));}
    return {get available(){return loaded&&!lost;},resize(w,h){
      const budget=w<700?650000:1300000;const ratio=Math.min(devicePixelRatio||1,1.5,Math.sqrt(budget/Math.max(1,w*h)));
      canvas.width=Math.max(1,Math.round(w*ratio));canvas.height=Math.max(1,Math.round(h*ratio));gl.viewport(0,0,canvas.width,canvas.height);
    },render(w,h,x,y,time,p){if(!loaded||lost||disposed)return;gl.useProgram(program);gl.uniform1i(uniforms.u_smoke,0);gl.uniform2f(uniforms.u_size,w,h);gl.uniform2f(uniforms.u_origin,x,y);gl.uniform1f(uniforms.u_time,time);gl.uniform1f(uniforms.u_progress,p);gl.drawArrays(gl.TRIANGLE_STRIP,0,4);},destroy(){disposed=true;img.onload=null;img.onerror=null;canvas.removeEventListener('webglcontextlost',onLost);cleanup();}};
  }
  // Older devices still get photographic smoke, with simpler drifting layers.
  function fallback(canvas,url,ready){
    const ctx=canvas.getContext('2d');if(!ctx)return null;
    let loaded=false,disposed=false,mask=null;const img=new Image();img.crossOrigin='anonymous';
    img.onload=()=>{if(disposed)return;try{
      mask=document.createElement('canvas');mask.width=640;mask.height=640;const m=mask.getContext('2d',{willReadFrequently:true});m.drawImage(img,0,0,640,640);const frame=m.getImageData(0,0,640,640);
      for(let i=0;i<frame.data.length;i+=4){const luminance=(frame.data[i]+frame.data[i+1]+frame.data[i+2])/3;frame.data[i]=85;frame.data[i+1]=88;frame.data[i+2]=84;frame.data[i+3]=Math.max(0,luminance-6)*.88;}
      m.putImageData(frame,0,0);loaded=true;ready();
    }catch{loaded=false;ready();}};img.onerror=()=>ready();img.src=url;
    const smooth=(a,b,x)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t);};
    return {get available(){return loaded;},resize(w,h){const ratio=Math.min(devicePixelRatio||1,1.25);canvas.width=w*ratio;canvas.height=h*ratio;ctx.setTransform(ratio,0,0,ratio,0,0);},render(w,h,x,y,time,p){ctx.clearRect(0,0,w,h);if(!loaded)return;const amp=smooth(.04,.59,p),clear=1-smooth(.55,.92,p),span=Math.min(w,h),sw=span*(.37+amp*2.9),sh=Math.min(h*.8,520)*(1+amp*2.6),ox=x+(w*.52-x)*amp*.85,oy=y+(h*.92-y)*amp*.85;
      for(let i=0;i<3;i++){ctx.save();ctx.globalAlpha=clear*(i===0?.72:amp*.42);ctx.translate(ox+Math.sin(time*.3+i)*sw*.035*(.2+amp),oy);ctx.rotate(Math.sin(time*.18+i)*.045);if(i===1)ctx.scale(-1,1);ctx.drawImage(mask,-sw*.5,-sh*.97,sw,sh);ctx.restore();}
    },destroy(){disposed=true;img.onload=null;img.onerror=null;mask=null;}};
  }
  return {create};
})();
